import { render } from "./AddYacht.vue?vue&type=template&id=3e2ce22c&scoped=true"
import script from "./AddYacht.vue?vue&type=script&lang=ts"
export * from "./AddYacht.vue?vue&type=script&lang=ts"

import "./AddYacht.vue?vue&type=style&index=0&id=3e2ce22c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3e2ce22c"

export default script